// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"de38d480","94":"2dd464fb","120":"184cc706","126":"cf7e7077","171":"106d1f7c","407":"20f906d3","432":"a88511f8","532":"cbd7cb5c","674":"336de9a2","684":"4a080e0c","711":"c6ccff93","744":"37bdfb87","994":"c9f375fd"}[chunkId] + ".chunk.js";
};